import { useState } from "react";
import { masked, unMasked } from "./InputMask";

export const PhoneInput = ({onChange, value}) => {
    const [inputValue, setInputValue] = useState(value);
    
    const handleOnChange = (val) => {
        setInputValue(val)
        onChange(val);
    }

    return (
        <input className="input-border input_contact" onChange={ (e) => handleOnChange(unMasked('phone', e.target.value)) } type="text" placeholder="+7 XXX XXX-XX-XX" value={ masked('phone', inputValue) } />
    )
}